<template>
  <div class="botaolinkhome">
    <div class="content">
    {{texto}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BotaoLinkHome',
  props: {
    texto: String
  }
}
</script>

<style scoped>
.botaolinkhome {
    background: rgb(26,87,213);
    background: linear-gradient(0deg, rgba(26,87,213,1) 0%, rgba(48,130,204,1) 100%);
    width: 200px;
    height: 200px;
    color: white;
    font-size: 1.2em;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-items: center;
    flex-direction: column;
}
.content {
    margin: auto;
}
</style>
